import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { InputSelector } from "../../components/Forms/InputSelector";
import { useEffect, useState } from "react";
import apiAgent from "../../api/apiAgent";
import { useNavigate, useParams } from "react-router";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel, userAtom } from "../../atoms";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import BaseForm from "../../components/Forms/BaseForm";
import { useSearchParams } from "react-router-dom";
import { useSetChangesMade } from "../../components/Publishing/utils";
import WorkPhotosForm from "./form";
import { WorkOrPhotosPreview } from "./previews/WorkOrPhotosPreview";

const CreateWorkPhotos = (): JSX.Element => {
  const params = useParams();
  const [originFrom, originId] = useOriginParams();

  const userData = useAtomValue(userAtom);
  const modelData = useAtomValue(modelDataAtom);
  const modelName = params.model?.toString() || "";
  useValidateModel(modelName);
  const setChangesMade = useSetChangesMade(modelName);

  const capitalizedName = checkTitle(modelName);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoading) {
      const [emptyData, getSchema, relationships] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );

      const dataWithParams = getSchema.reduce((obj, item) => {
        const key = item.name;
        const checkValue = searchParams.get(key);
        if (searchParams.get(key))
          return {
            ...obj,
            [key]: checkValue,
          };
        return obj;
      }, {});

      const originValues =
        originFrom && originId
          ? {
              [`owner${originFrom}Id`]: parseInt(originId || "-1"),
            }
          : {};

      setItemData({ ...emptyData, ...dataWithParams, ...originValues });
      setSchema(getSchema);
      setIsLoading(false);
    }
  }, [modelData]);

  const saveItem = async () => {
    try {
      const getCurrent = await apiAgent.DataType.getAll(modelName);

      const response = await apiAgent.DataType.create(modelName, {
        ...itemData,
        editedBy: userData?.id,
        sortId: getCurrent?.data?.length || 1,
        type: "image",
      });

      if (response.status === 200) {
        tMsg.success(`Slide successfully created`);
        setChangesMade();
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}`);
        else if (response?.data?.newId)
          navigate(`/m/${modelName}/show/${response.data.newId}`);
        else navigate(`/m/${modelName}`);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error creating slide`);
      console.log(err);
    }
  };

  const crumbs = [
    {
      label: checkTitle(modelName),
      link: `/m/${modelName}`,
    },
  ];

  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Create ${capitalizedName}`}>
          <BackButton />
        </TitleBar>
        <WorkPhotosForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem();
          }}
        />
        <WorkOrPhotosPreview itemData={itemData} />
      </PageContent>
      <PageFooterBar>
        <SaveButton />
      </PageFooterBar>
    </PageContainer>
  );
};

export default CreateWorkPhotos;
